import * as React from 'react';
import { useState } from 'react';
import { AdvisingPurchase } from '../../Types/Advising';
import { EssayReview } from '../../Types/Essays';
import PackageCard from './PackageCard';

type Props =
  { customerName: string
  , customerUserId: number
  , advisingPurchases: AdvisingPurchase[]
  , essayReviews: EssayReview[]
  , backUrl: string
  , isAdmin: boolean
  }

function messagesPathForCustomerUserId(customerUserId: number) {
  return `/messages?other_user_id=${customerUserId}`
}


const ClientDetails = (props: Props) => {
  const ViewMessagesButton = () => (
    <a className="btn btn-outline-primary px-3 ms-2" href={messagesPathForCustomerUserId(props.customerUserId)}>
      Messages
    </a>
  )

  return (
    <div>
      <div className="row align-items-center">
        <div className="col-auto d-flex align-items-center">
          <a href={props.backUrl} className="text-decoration-none align-items-center d-flex">
            <i className="ai-arrow-left me-1"/>
            <i className="ai-grid me-1"/>
            Back
          </a>
        </div>
        <div className="col d-flex justify-content-end mt-1 mt-md-0">
          <ViewMessagesButton />
        </div>
      </div>
      <h4 className="mt-3 mb-0">{props.customerName}</h4>
      <div className="mt-3">
        {props.advisingPurchases.filter((purchase) => !!purchase.packageName).map((purchase, index) => (
          <div>
            <PackageCard
              purchase={purchase}
              isAdmin={props.isAdmin}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ClientDetails
